import React from 'react';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import AuthRoutes from '@tenant/utility/AuthRoutes';
import AppContextProvider from '@tenant/utility/AppContextProvider';
import AppThemeProvider from '@tenant/utility/AppThemeProvider';
import AppStyleProvider from '@tenant/utility/AppStyleProvider';
import AppLocaleProvider from '@tenant/utility/AppLocaleProvider';
import AppLayout from '@tenant/core/AppLayout';
import store, { persistor } from 'redux/store';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import FirebaseAuthProvider from '@tenant/services/auth/firebase/FirebaseAuthProvider';
import QueryClientProvider from 'services/QueryClientProvider';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import PropTypes from 'prop-types';
import { PersistGate } from 'redux-persist/integration/react';
import AppLoader from '@tenant/core/AppLoader';
import { WhatsNewAutoDisplay } from 'components/WhatsNew';

const App = ({ instance }) => (
  <QueryClientProvider>
    <AppContextProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={<AppLoader />}>
          <AppThemeProvider>
            <AppStyleProvider>
              <AppLocaleProvider>
                <BrowserRouter>
                  <FirebaseAuthProvider>
                    <MsalProvider instance={instance}>
                      <AuthRoutes>
                        <CssBaseline />
                        <AppLayout />
                        <WhatsNewAutoDisplay />
                        <ToastContainer
                          position='bottom-right'
                          autoClose={5000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                        />
                      </AuthRoutes>
                    </MsalProvider>
                  </FirebaseAuthProvider>
                </BrowserRouter>
              </AppLocaleProvider>
            </AppStyleProvider>
          </AppThemeProvider>
        </PersistGate>
      </Provider>
    </AppContextProvider>
  </QueryClientProvider>
);

export default App;

App.propTypes = {
  instance: PropTypes.object.isRequired,
};
